import { useEffect, useState } from "react"
import './index.css'
import DataTable from "../common/DataTable"
import { columns, handleDoubleClickRow } from "./scheme"
import ActionModal from "../common/ActionModal"
import { SubmitHandler } from "react-hook-form"
import { DataUser, UserFormModel } from "../../models/user.model"
import { createUser, editUser, filterUsers, getUser } from "../../services/user.service"
import UserForm from "./UserForm"
import { getPersons, getProfiles } from "../../services/autocomplete.service"
import { itemSelection } from "../../models/itemSelection.model"
import { PERSON_DEFAULT_PROFILE } from "../../assets/appConstants/users"
import { useNotification } from "../../context/NotificationContext"


export default function UsersListing({ setBlockScreen, openActionModal, setOpenActionModal, action,
  setAction, canEdit }: any) {

  const { showNotification } = useNotification();
  const [loadingList, setLoadingList] = useState<boolean>(false)
  const [reloadList, setReloadList] = useState(false)

  const [userId, setUserId] = useState<string>('')

  const [fieldErrors, setFieldErrors] = useState<string[]>([])

  const [profilesList, setProfilesList] = useState<itemSelection[]>([])
  const [personsList, setPersonsList] = useState<itemSelection[]>([])

  const initialForm: UserFormModel = {
    username: '',
    person: { id: '', label: '' },
    profile: PERSON_DEFAULT_PROFILE,
    created_date: '',
    last_login_date: '',
    enabled: 'true',
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement> | { 'target': { 'name': any, 'value': any } }): void => {
    setUserForm({
      ...userForm,
      [event.target.name]: event.target.value
    });
  }

  const handleSelection = (key: string, value: string): void => {
    setUserForm({
      ...userForm,
      [key]: value
    });
  }

  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUserForm({
      ...userForm,
      [event.target.name]: event.target.checked ? 'true' : 'false'
    });
  };

  const [userForm, setUserForm] = useState<UserFormModel>(initialForm)
  const [usersList, setUsersList] = useState<DataUser[]>([])

  const errorFields = () => {
    let errors: string[] = []
    if (userForm.username.length === 0) errors.push('username')
    if (action !== 'edit' && !userForm.person?.id) errors.push('person')
    setFieldErrors(errors)

    return errors.length > 0
  }

  const initComponent = () => {
    setBlockScreen(true)
    Promise.all([getProfiles(), getPersons()
    ]).then(function (result: any[]) {
      setProfilesList(result[0])
      setPersonsList(result[1])
      setBlockScreen(false)
    }).catch((error) => {
      showNotification(<span>Error obteniendo lista de Personas o Perfiles</span>, 'error')
      setBlockScreen(false)
    });
  }

  useEffect(initComponent, [])

  const handleCloseDetail = () => {
    setOpenActionModal(false)
    setUserId('')
    setAction('view')
    setUserForm(initialForm)
    setFieldErrors([])
  }

  const fetchDataTable = () => {
    setLoadingList(true)
    Promise.all([filterUsers({})
    ]).then(function (result: any[]) {
      setUsersList(result[0])
      setTimeout(() => { setLoadingList(false) }, 1000)
    }).catch((error) => {
      showNotification(<span>Error obteniendo la lista de usuarios</span>, 'error')
      setTimeout(() => { setLoadingList(false) }, 1000)
    });
  };

  useEffect(fetchDataTable, [reloadList])

  const fetchUser = () => {
    if (userId) {
      setBlockScreen(true)
      Promise.all([getUser(userId)
      ]).then(function (result: any[]) {
        setUserForm(result[0])
        setOpenActionModal(true)
        setBlockScreen(false)
      }).catch((error) => {
        showNotification(<span>Error: {error.response.data}</span>, 'error')
        setBlockScreen(false)
      });
    }
  }

  useEffect(fetchUser, [userId])

  const onSubmitCreate: SubmitHandler<UserFormModel> = () => {
    if (!errorFields()) {
      setBlockScreen(true)
      Promise.all([createUser(userForm)
      ]).then(function (result: any[]) {
        setTimeout(() => {
          showNotification(<span>Se ha creado el usuario <i>{result[0]['username']}</i></span>)
          handleCloseDetail()
          setReloadList(!reloadList)
        }, 1000)
        setBlockScreen(false)
      }).catch((error) => {
        showNotification(<span>{error.response.data}</span>, 'error')
        setBlockScreen(false);
      });
    }
  }

  const onSubmitEdit: SubmitHandler<UserFormModel> = () => {
    if (!errorFields()) {
      setBlockScreen(true)
      Promise.all([editUser(userId, userForm)
      ]).then(function (result: any[]) {
        setTimeout(() => {
          showNotification(<span>Se ha editado el usuario <i>{result[0]['username']}</i></span>)
          handleCloseDetail()
          setBlockScreen(false)
          setReloadList(!reloadList)
        }, 1000)
      }).catch((error) => {
        showNotification(<span>{error.response.data} </span>, 'error')
        setBlockScreen(false);
      });
    }
  }

  const handleDoubleClickTitle = (event: any) => {
    handleDoubleClickRow(event, setUserId)
  }

  return (
    <>
      <ActionModal
        title={action === 'create' ? 'Nuevo Usuario' : 'Usuario'}
        openModal={openActionModal}
        handleCloseModal={handleCloseDetail}
        mode={action}
        setMode={setAction}
        handleCreate={onSubmitCreate}
        handleEdit={onSubmitEdit}
        removable={false}
        canEdit={canEdit}
        children={<UserForm action={action}
          userForm={userForm}
          handleChange={handleChange}
          handleSelection={handleSelection}
          handleCheck={handleCheck}
          profilesList={profilesList}
          personsList={personsList}
          errors={fieldErrors}
        />}
      />

      <DataTable
        columns={columns}
        rows={usersList}
        handleDoubleClick={handleDoubleClickTitle}
        loading={loadingList}
      />

    </>
  );
}
